export default {
  addressErrors: {
    invalidCountry: {
      en: 'Sorry, we do not support shipping to the selected country.',
    },
    invalidCountryBecauseOfMID: {
      en: 'Please use an address from the country you selected before.',
    },
    response: {
      en: 'Something went wrong till request. Please try again later or select a different address.',
    },
    validation: {
      en: 'The address you selected is not valid.<br />Please update selected address or select a different address.',
    },
    unknown: {
      en: `
        We\`re having technical issues at that moment. Please try again later or contact our customer support
        at <a href="mailto:support@scentbird.com">support@scentbird.com</a>
      `,
    },
  },
  updateMethodButton: {
    en: 'Update payment method',
  },
  addMethodButton: {
    en: 'Add payment method',
  },
}
